import { gql } from 'glimmer-apollo';

export const ESPORTS_TOURNAMENT_QUERY = gql`
  query ($slug: String) {
    tournament(slug: $slug) {
      id
      title
      slug
      name
      game {
        id
        name
        title
        slug
        image {
          url(width: 200, height: 200, fit: cover, format: webp)
          title
          description
        }
      }
      teams {
        id
        slug
        name
        wins
        losses
        kills
        deaths
        assists
        kda
        logo {
          url(width: 32, height: 32, fit: cover, format: webp)
        }
      }
      matches {
        id
        slug
        title
        name
        scheduledDate
        isFinal
        isLive
        bestOf
        teams {
          id
          name
          slug
          country
          logo {
            url(width: 32, height: 32, fit: cover, format: webp)
          }
        }
        victor {
          id
          name
          slug
        }
        rounds {
          embedUrl
          victor {
            slug
          }
        }
      }
      isLive
      isFinal
      liveVideoUrl
      liveChatUrl
      startDate
      endDate
      prize
      image {
        url(width: 400, height: 200, fit: cover, format: webp)
        title
        description
      }
      featuredPlayer {
        id
        slug
        gamertag
        irlName
        role
        photo {
          url(width: 80, height: 100, fit: cover, format: webp)
        }
        currentTeam {
          name
          logo {
            url(width: 44, height: 44, fit: cover, format: webp)
          }
        }
      }
      victor {
        id
        slug
        name
        logo {
          url(width: 64, height: 64, fit: cover, format: webp)
        }
      }
    }
  }
`;
